// 主题模块服务层

import { themeApi } from "../api";
import { Theme } from "../types";
import { useThemeStore } from "../stores";

// 主题服务类
export class ThemeService {
  private static instance: ThemeService;

  static getInstance(): ThemeService {
    if (!ThemeService.instance) {
      ThemeService.instance = new ThemeService();
    }
    return ThemeService.instance;
  }

  // 主题配置服务
  async loadTheme(themeId?: string): Promise<Theme> {
    const { setThemeLoading, setTheme, getCache, setCache } =
      useThemeStore.getState();

    // 检查缓存
    const cacheKey = `theme_config_${themeId || "default"}`;
    const cached = getCache(cacheKey);
    if (cached) {
      setTheme(cached);
      return cached;
    }

    try {
      setThemeLoading(true);

      const data = await themeApi.getTheme(themeId || "default");

      // 缓存数据
      setCache(cacheKey, data, 60 * 60 * 1000); // 1小时缓存
      setTheme(data);

      return data;
    } catch (error) {
      console.error("主题配置加载失败:", error);
      throw error;
    } finally {
      setThemeLoading(false);
    }
  }

  // 获取主题列表
  async loadThemeList(): Promise<Theme[]> {
    const { getCache, setCache } = useThemeStore.getState();

    // 检查缓存
    const cacheKey = "theme_list";
    const cached = getCache(cacheKey);
    if (cached) {
      return cached;
    }

    try {
      const data = await themeApi.getThemeList();

      // 缓存数据
      setCache(cacheKey, data, 30 * 60 * 1000); // 30分钟缓存

      return data;
    } catch (error) {
      console.error("主题列表加载失败:", error);
      return [];
    }
  }
}

// 创建单例实例
export const themeService = ThemeService.getInstance();

// 导出便捷方法
export const { loadTheme, loadThemeList } = themeService;
